

















import { Vue, Component, Prop } from "vue-property-decorator";
import StoricoAttivita from "../StoricoAttivita.vue";
import { bus } from "../../main"

@Component({
    components: {
        StoricoAttivita
    }
})
export default class StoricoAttivitaDialog extends Vue {
    @Prop() soggetto!: string; //indica in base a quale soggetto sto guardando lo storico
    @Prop() idSoggetto!: number;
    @Prop() nomeSoggetto!: string;
    private storicoDialog: boolean;

    constructor() {
        super();
        this.storicoDialog = false;
    }

    close() {
        this.storicoDialog = false
        bus.$emit("destroyStoricoDialog");
    }
}
